import Model, { attr, belongsTo } from "@ember-data/model";
import { tKey } from "ember-intl";

export default class ServerBackupModel extends Model {
  @attr("string") frequency;
  @attr("string") type;
  @attr("date") createdAt;
  @attr("date") completedAt;
  @attr("date") snapshotTakenAt;
  @attr("number") diskInGiB;

  @belongsTo("server", { async: false, inverse: "backups" }) server;

  get frequencyTranslationKey() {
    switch (this.frequency) {
      case "daily":
        return tKey("server.details.backup.schedules.daily");
      case "weekly":
        return tKey("server.details.backup.schedules.weekly");
      case "monthly":
        return tKey("server.details.backup.schedules.monthly");
      default:
        return tKey("server.details.backup.schedules.custom");
    }
  }
}
